import React from 'react';
import {useEnvValue} from "@morningtrain/react-helpers";

export default function WhenViewingChecklistInstance(props) {

    const [focusedChecklist] = useEnvValue('checklist.focused_list', null);

    if (focusedChecklist === null) {
        return null;
    }

    return props.children;
}
